import { createContext, useCallback, useContext, useMemo, useState } from "react";

const ConciergeContext = createContext({ open: false, setOpen: () => {}, ask: () => {}, pending: null, clearPending: () => {} });

export function ConciergeProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(null);
  const ask = useCallback((msg) => {
    setPending(msg || null);
    setOpen(true);
  }, []);
  const clearPending = useCallback(() => setPending(null), []);
  const value = useMemo(() => ({ open, setOpen, ask, pending, clearPending }), [open, ask, pending, clearPending]);
  return <ConciergeContext.Provider value={value}>{children}</ConciergeContext.Provider>;
}

export const useConcierge = () => useContext(ConciergeContext);
